/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ submitted: NonNullable<unknown>, total: NonNullable<unknown>, failed: NonNullable<unknown> }} Embed_Captions_Batch_Result_TextInputs */

const en_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.submitted} of ${i?.total} embed jobs were submitted. ${i?.failed} failed to upload and remain in the list so you can try again.`)
};

const fr_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.submitted} tâches d'intégration sur ${i?.total} ont été soumises. ${i?.failed} n'ont pas pu être envoyées et restent dans la liste pour que vous puissiez réessayer.`)
};

const de_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.submitted} von ${i?.total} Einbettungsjobs wurden eingereicht. ${i?.failed} konnten nicht hochgeladen werden und bleiben in der Liste, damit Sie es erneut versuchen können.`)
};

const it_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sono stati inviati ${i?.submitted} lavori di incorporamento su ${i?.total}. ${i?.failed} non sono stati caricati e restano nell'elenco per poter riprovare.`)
};

const ru_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправлено ${i?.submitted} из ${i?.total} заданий на встраивание. Не удалось загрузить: ${i?.failed}; эти файлы остаются в списке, чтобы вы могли повторить попытку.`)
};

const es_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se enviaron ${i?.submitted} de ${i?.total} trabajos de incrustación. ${i?.failed} no se pudieron cargar y permanecen en la lista para que pueda intentarlo de nuevo.`)
};

const zh_cn2_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已提交 ${i?.total} 个嵌入任务中的 ${i?.submitted} 个。${i?.failed} 个上传失败，已保留在列表中以便重试。`)
};

const ja_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} 件中 ${i?.submitted} 件の埋め込みジョブを送信しました。${i?.failed} 件はアップロードに失敗したため、再試行できるようリストに残っています。`)
};

const hi_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} में से ${i?.submitted} एम्बेड जॉब सबमिट किए गए। ${i?.failed} अपलोड नहीं हो सके और सूची में बने रहेंगे ताकि आप फिर से प्रयास कर सकें।`)
};

const pt_pt2_embed_captions_batch_result_text = /** @type {(inputs: Embed_Captions_Batch_Result_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foram enviados ${i?.submitted} de ${i?.total} trabalhos de incorporação. ${i?.failed} não foram carregados e permanecem na lista para que possa tentar novamente.`)
};

/**
* | output |
* | --- |
* | "{submitted} of {total} embed jobs were submitted. {failed} failed to upload and remain in the list so you can try again." |
*
* @param {Embed_Captions_Batch_Result_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_batch_result_text = /** @type {((inputs: Embed_Captions_Batch_Result_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Batch_Result_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_batch_result_text(inputs)
	if (locale === "de") return de_embed_captions_batch_result_text(inputs)
	if (locale === "it") return it_embed_captions_batch_result_text(inputs)
	if (locale === "ru") return ru_embed_captions_batch_result_text(inputs)
	if (locale === "es") return es_embed_captions_batch_result_text(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_batch_result_text(inputs)
	if (locale === "ja") return ja_embed_captions_batch_result_text(inputs)
	if (locale === "hi") return hi_embed_captions_batch_result_text(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_batch_result_text(inputs)
	return en_embed_captions_batch_result_text(inputs)
});